export enum ConfigTabType {
  IgnoredQIDs = 'auto-ignored-vulnerabilities',
  ExcludedQIDs = 'excluded-vulnerabilities-(deprecated)',
  CAActivationKeys = 'manage-cloud-agent-activation-keys',
}
